<template>
  <div class="mappingItem">
    <b-modal
      id="field-mapping-modal"
      hide-footer
      centered
    >
      <template #modal-header>
        <span class="text-border">{{ itemMstMapped.isItemName }}</span
        ><span>{{ `（${itemMstMapped.dataTypeName}） ` }}</span>
        <tooltip-component
          :title="`${tooltipBaseOnDataType}`"
          v-b-tooltip.html="{
            placement: 'bottom'
          }"
        />
      </template>
      <div class="mapping-items-modal-container">
        <div class="form-mapping-value">
          <div class="mapping-item-group mb-2">
            <span class="label">1.で定義した項目</span>
            <div class="mapping-item">
              <form-select-component
                :id="idLabel"
                v-model="selectValueMapping"
                class="select-value"
                placeholder=""
                :options="itemWmsMappingList"
                @change="changeMapping"
              >
                <template v-slot:singleLabel="{ itemLabel }">
                  {{itemLabel.option.wmsItemName}}
                </template>
                <template v-slot:options="{ itemOption }">
                  {{itemOption.option.lineNum }} .&emsp; {{ itemOption.option.wmsItemName}}
                </template>
              </form-select-component>
              <a
                class="clear-select"
                @click="clearMapping"
              >
                <span class="material-icons icon-close"> close </span>
                クリア
              </a>
            </div>
          </div>
          <div class="mapping-item-group">
            <span class="label">指定の初期値</span>
            <div class="mapping-item">
              <input-text-component
                class="input-value"
                id="mapping-item-text"
                v-model="defaultValue"
                :placeholder="`${placeHolderField}`"
                :maxlength="getRulesMinMax(rulesMinMaxValue)"
                :enableTrimValue="true"
                v-if="dataType === 0"
              />
              <input-number-component
                class="input-value"
                id="mapping-item-number"
                v-model.number="defaultValue"
                :maxValue="getRulesMinMax(rulesMinMaxValue)"
                :minValue="getRulesMinMax(rulesMinMaxValue, false)"
                :placeholder="`${placeHolderField}`"
                v-if="dataType === 1"
              />
              <form-select-component
                class="select-value"
                v-model="selectUserDefine"
                :options="listMstGenCode.map(genCode => genCode.value)"
                :customLabel="opt => getGenCodeName(listMstGenCode, opt)"
                :placeholder="`${placeHolderFieldForList}`"
                v-if="dataType === 2"
              />
              <a class="clear-select" @click="handleCleanData">
                <span class="material-icons icon-close"> close </span>
                クリア
              </a>
            </div>
          </div>
        </div>
        <div class="table-prioritized">
          <div class="table-prioritized-title">
            <span class="table-prioritized-title__left">値の対応例</span>
            <span
              >マッピングで指定した初期値よりもアップロードデータの値が優先されます。</span
            >
          </div>
          <div class="table-prioritized-body">
            <div class="table-prioritized-row">
              <div class="column-left">
                <span class="text-label">初期値<br />=50</span>
                <span class="material-icons arrow-left">
                  keyboard_arrow_left
                </span>
                <span class="text-label">指定した初期値<br />=60</span>
                <span class="material-icons arrow-left">
                  keyboard_arrow_left
                </span>
                <span class="text-label">アップロードデータ<br />=100</span>
              </div>
              <div class="column-right">
                <span class="text-label">実行時データ<br />=100</span>
              </div>
            </div>
            <div class="table-prioritized-row">
              <div class="column-left">
                <span class="text-label">初期値<br />=50</span>
                <span class="material-icons arrow-left">
                  keyboard_arrow_left
                </span>
                <span class="text-label">指定した初期値<br />=60</span>
                <span class="material-icons arrow-left">
                  keyboard_arrow_left
                </span>
                <span class="text-label">アップロードデータ<br />= [空白]</span>
              </div>
              <div class="column-right">
                <span class="text-label">実行時データ<br />=60</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <b-button
            id="save_mapping"
            class="btn_blue"
            @click="onMappingItem"
          >
            OK
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import InputNumberComponent from '../custom-components/InputNumberComponent.vue'
import InputTextComponent from '../custom-components/InputTextComponent.vue'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import RulesValidate from '../../common/rules-validate.js'
import StrinngUtil from '../../_helpers/string.util'
import { FieldDataType } from '../../enums/field-data-type.enums.js'
import TooltipComponent from '../../components/custom-components/TooltipComponent.vue'
import AppConstants from '../../constants/app.constants'
export default {
  components: {
    InputNumberComponent,
    InputTextComponent,
    FormSelectComponent,
    FieldDataType,
    TooltipComponent
  },
  props: {
    itemWmsMappingList: {
      type: Array,
      default: null
    },
    tableManagementList: {
      type: Array,
      default: null
    },
    replacedCharacters: {
      type: String
    },
    placeHolderFieldForList: {
      type: String
    }
  },
  data() {
    return {
      id: '',
      dataType: '',
      defaultValue: null,
      selectUserDefine: null,
      listMstGenCode: [],
      selectValueMapping: {},
      selectValueMappingDefault: { wmsItemName: '指定なし', wmsNo: 0 },
      rulesMinMaxValue: [],
      itemMstMapped: {},
      idLabel: '',
      systemDefaultValue: '',
      tooltipBaseOnDataType: '',
      systemDefaultExplanation: '',
      placeHolderField: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    /**
     * チェックを入れると、Gen コード名または Gen コード番号が表示されます。
     * @param {number} genCodes 生成コードを確認したい
     * @param {number} selectedGenCodeValue 世代コードが選択されました
     * @return 生成コードが存在する場合は生成コード名を表示し、存在しない場合は選択した生成コードを表示します。
     */
    getGenCodeName(genCodes, selectedGenCodeValue) {
      if (!genCodes.length) {
        return selectedGenCodeValue
      }
      const genCode = genCodes.find(x => x.value.toString() === selectedGenCodeValue.toString())
      if (!genCode) {
        return selectedGenCodeValue
      }
      return genCode.text
    },
    /**
     * マッピングモーダルを表示
     * @param {object} itemMstMapped     アイテム選択マッピング
     * @param {number} id                選択されたアイテムのID
     * @param {object} rulesMinMaxValue  ルールの検証
     */
    async showModal(itemMstMapped, id, rulesMinMaxValue = null) {
      this.itemMstMapped = { ...itemMstMapped }
      this.id = id
      this.dataType = this.itemMstMapped.dataType
      switch (this.dataType) {
        case FieldDataType.STRING:
          this.tooltipBaseOnDataType = '禁止文字以外であれば入力可能な項目です。禁止文字一覧: ' + this.replacedCharacters.replaceAll(',', '、').replace('\\\\', '\\')
          break
        case FieldDataType.NUMBER:
          this.tooltipBaseOnDataType = '数字（0～9）のみ入力可能な項目です。'
          break
        case FieldDataType.LIST:
          this.tooltipBaseOnDataType = '一覧から選択可能な項目です。'
          break
        case FieldDataType.DATE:
          this.tooltipBaseOnDataType = '日付形式で入力可能な項目です。'
          break
      }
      this.idLabel = `mapping-item-${id}`
      this.buildListMstGenCode()
      this.fetchData()
      this.rulesMinMaxValue = rulesMinMaxValue
        ? rulesMinMaxValue[`${this.itemMstMapped.isItemNo}`].rules
        : []
      if (!this.selectUserDefine) {
        this.selectUserDefine = this.itemMstMapped.defaultValue
      }
      await this.$bvModal.show('field-mapping-modal')
    },
    /** 値を文字列に変換 */
    convertValueToString() {
      // 値を文字列に変換
      this.defaultValue = StrinngUtil.toString(this.defaultValue)
      this.selectUserDefine = StrinngUtil.toString(this.selectUserDefine)
    },
    /** マッピング項目 */
    onMappingItem() {
      this.convertValueToString()
      // If user don't mapping wms item, set variable selectValueMapping is empty
      if (!this.selectValueMapping || !this.selectValueMapping.wmsNo) {
        this.selectValueMapping = {}
      }
      const wmsItem = this.selectValueMapping
      let userDefaultValue
      if (this.dataType === FieldDataType.LIST) {
        userDefaultValue = this.selectUserDefine
      } else {
        userDefaultValue = this.defaultValue
      }
      wmsItem['defaultValue'] = userDefaultValue
      this.$emit('on-mapping', wmsItem, this.id)
      this.$bvModal.hide('field-mapping-modal')
    },
    /**
     * マッピング更新の際に行われる。
     */
    changeMapping() {
      // マッピングがバッチ番号でWMS項目で指定済みの場合、プレースホルダーをクリアする
      if (this.itemMstMapped && this.itemMstMapped.isItemNo === AppConstants.IS_ITEM_FIELD_BATCH_NO && this.itemMstMapped.tableNo === AppConstants.IS_ITEM_FIELD_TR_TASK && this.selectValueMapping.wmsNo) {
        this.itemMstMapped.systemDefaultExplanationFlag = false
        this.placeHolderField = this.getPlaceHolderField()
      }
    },
    /**
     * マッピングが削除される際に行われる。
     */
    clearMapping() {
      this.selectValueMapping = this.selectValueMappingDefault
      // マッピングがバッチ番号で必須でない場合、プレースホルダーをシステムデフォルトにする
      if (this.itemMstMapped && this.itemMstMapped.isItemNo === AppConstants.IS_ITEM_FIELD_BATCH_NO && this.itemMstMapped.tableNo === AppConstants.IS_ITEM_FIELD_TR_TASK && !this.itemMstMapped.isItemRequiredFlag) {
        this.itemMstMapped.systemDefaultExplanationFlag = true
        this.placeHolderField = this.getPlaceHolderField()
      }
    },
    /** データを取得する */
    fetchData() {
      if (
        !this.itemMstMapped &&
        !this.itemWmsMappingList &&
        !this.tableManagementList
      ) {
        return
      }
      let userDefaultValue = this.itemMstMapped.defaultValue
      this.placeHolderField = this.getPlaceHolderField()
      if (this.dataType === FieldDataType.LIST) {
        this.selectUserDefine = this.getGenCodeValue(userDefaultValue)
      } else {
        this.defaultValue = userDefaultValue || ''
      }
      this.convertValueToString()
      const wmsItem = this.itemWmsMappingList.find(
        item => item.wmsNo === this.itemMstMapped.wmsNo
      )
      // If user don't map item, set value default for selectValueMapping is unspecified
      this.selectValueMapping = wmsItem || this.selectValueMappingDefault
    },
    /** mst gen-code リストの作成 */
    buildListMstGenCode() {
      this.listMstGenCode = []
      const mstTable = this.tableManagementList.find(
        tableManagement =>
          tableManagement.isItemNo === this.itemMstMapped.isItemNo
      )
      if (mstTable && this.dataType === FieldDataType.LIST) {
        mstTable.mstGenCode.map(genCode => {
          // Add genCode into list listMstGenCode
          const mstGenCode = { value: genCode.code, text: genCode.name }
          this.listMstGenCode.push(mstGenCode)
        })
      }
    },
    /**
     * ルールの検証を取得
     * @param {array} rules ルール
     * @param {boolean} isMax 最大ルール
     */
    getRulesMinMax(rules, isMax = true) {
      return RulesValidate.getMinMaxValue(rules, isMax)
    },
    /** きれいなデータ */
    handleCleanData() {
      this.selectUserDefine = null
      this.defaultValue = null
    },
    /**
     * 生成コード項目が生成コードリストに存在することを確認してください。
     * @param {number} genCodeValue 生成コードを確認したい
     * @return gen コードが存在する場合はそれを返し、存在しない場合は null を返します
     */
    getGenCodeValue(genCodeValue) {
      const foundGenCode = this.listMstGenCode.find(item => item.value === parseInt(genCodeValue))
      return foundGenCode ? genCodeValue : null
    },
    /**
     * システムデフォルト値、システムデフォルト説明、システムデフォルト説明フラグでプレースホルダを決める。
     * @return プレースホルダ
     */
    getPlaceHolderField() {
      let placeHolderField = ''
      if (this.itemMstMapped) {
        if (this.itemMstMapped.systemDefaultValue) {
          placeHolderField = this.itemMstMapped.systemDefaultValue
        } else if (this.itemMstMapped.systemDefaultExplanation && this.itemMstMapped.systemDefaultExplanationFlag) {
          placeHolderField = this.itemMstMapped.systemDefaultExplanation
        }
      }
      return placeHolderField
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .modal-dialog {
  max-width: 40vw !important;
  min-width: 650px !important;
  width: 40vw !important;
}
/deep/ .modal-content {
  width: 100%;
}
/deep/ .modal-body {
  padding: 20px 24px 16px 24px;
}
/deep/ .modal-header {
  height: 45px;
  padding: 8px 16px 8px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .text-border {
    @include responsive-fs(18);
    font-weight: 700;
    max-width: 450px;
    @include textOverflowEllipsis();
  }
}
.system-default-label {
  color: #7c7c7a;
}
.mapping-items-modal-container {
  display: flex;
  flex-direction: column;
  .form-mapping-value {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    .mapping-item-group {
      display: flex;
      align-items: center;
      width: 100%;
      .label {
        white-space: nowrap;
        width: 28% !important;
        min-width: 150px;
      }
      .mapping-item {
        display: flex;
        align-items: center;
        flex: 1;
        width: 100%;
        .select-value {
          // flex: 1 1 300px;
          width: 20vw;
          min-width: 330px;
          border-radius: 4px;
        }
        .input-value {
          height: 40px;
          // flex: 1;
          width: 20vw;
          min-width: 330px;
          border-radius: 4px;
          border: 1px solid #ced4da;
        }
      }
    }
    .clear-select {
      display: flex;
      align-items: center;
      text-decoration: none;
      white-space: nowrap;
      cursor: pointer;
      @include responsive-fs(18);
      height: 40px;
      margin-left: 13px;
    }
  }
  .table-prioritized {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 25px 0px 0px;
    width: 100%;
    .table-prioritized-title {
      display: flex;
      align-items: flex-start;
      @include responsive-fs(12);
      &__left {
        white-space: nowrap;
        font-weight: 700;
        padding-right: 16px;
      }
    }
    .table-prioritized-body {
      display: flex;
      flex-direction: column;
      width: 100%;
      .table-prioritized-row {
        display: flex;
        flex: 1;
        border: 1px solid #afafae;
        .column-left,
        .column-right {
          display: flex;
          align-items: center;
        }
        .column-left {
          justify-content: center;
          flex: 1;
          padding: 0px 16px;
          gap: 16px;
          background: #f8f8f8;
          border-right: 1px solid #afafae;
          .arrow-left {
            width: 32px;
            height: 32px;
            color: #afafae;
          }
        }
        .column-right {
          padding: 8px 15px;
          background: rgba(78, 102, 166, 0.08);
          border-left: none;
          .text-label {
            font-weight: 700;
          }
        }
        .text-label {
          text-align: center;
          @include responsive-fs(12);
          line-height: 120%;
        }
        &:first-child {
          border-bottom: none;
        }
      }
    }
  }
  .footer {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    /deep/.btn_blue {
      width: 72px;
    }
  }
}
/deep/ .material-icons.icon-close {
  @include responsive-fs(14, true);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CommonFieldMappingModal.vue